import {RankedDivisionTypes, RankedSubDivisionTypes} from '../leaderboard_data/LeaderboardEnums'
import {DivisionBoundary, RankedDivisionState} from '@colonist/leaderboard-types'

export module RankedUtils {
    export function isFirstDivisionBoundaryHigherThan(firstDivision: DivisionBoundary, secondDivision: DivisionBoundary): boolean {
        return RankedUtils.isFirstDivisionHigherThan(firstDivision.division, firstDivision.subdivision, secondDivision.division, secondDivision.subdivision)
    }

    export function isFirstRankedStateHigherThan(firstRankedState: RankedDivisionState, secondRankedState: RankedDivisionState) {
        return RankedUtils.isFirstDivisionHigherThan(firstRankedState.divisionType, firstRankedState.subdivisionType, secondRankedState.divisionType, secondRankedState.subdivisionType)
    }

    export function isFirstDivisionHigherThan(firstDivisionType: RankedDivisionTypes, firstSubdivisionType: RankedSubDivisionTypes, secondDivisionType: RankedDivisionTypes, secondSubdivisionType: RankedSubDivisionTypes): boolean {
        if(firstDivisionType < secondDivisionType) return true
        if(firstDivisionType > secondDivisionType) return false
        if(firstSubdivisionType < secondSubdivisionType) return true
        return false
    }
}
